/* fs-gg-photos.js (FIX ROUND 1, Nov 2 2026). STAGED, OFF. On a PREVIEW theme only, an address ending in ?fsphotos=real swaps the gift guide's photos for the real Drive photos
   (every <img> that carries data-real-src). Does nothing on the live theme and nothing without the address flag. The theme switch in snippets/fs-hg-real-photo.liquid is the permanent route. */
(function () {
  if (window.__fsGgPhotos) return; window.__fsGgPhotos = true;
  var isMain = (window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  if (isMain || !/[?&]fsphotos=real(&|$)/.test(location.search)) return;
  function swap() {
    document.querySelectorAll('img[data-real-src]').forEach(function (img) {
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = img.getAttribute('data-real-src'); img.setAttribute('data-real-applied', '1');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swap); else swap();
})();
